// ==============================================
// ==================Import======================
// ==============================================

// ===================Dependancies================
import PropTypes from 'prop-types';

// ==================Style&IMG===================
import './style.scss';

function SessionView({ sessionViewData }) {
  return (
    <div className="tab-pane fade show active" id="sessionView-tab-pane" role="tabpanel" aria-labelledby="sessionView-tab" tabIndex="0">
      <table id="metadatasummary">
        <thead>
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Antenna</th>
            <th scope="col">Antenna SN</th>
            <th scope="col">Radome</th>
            <th scope="col">Receiver</th>
            <th scope="col">Receiver SN</th>
            <th scope="col">Firmware</th>
            <th scope="col">Satellite systems</th>
          </tr>
        </thead>
        <tbody>
          {sessionViewData.map((elem, i) => (
            <tr key={
              elem.dateto
              + Object.keys(elem.dateto)
              + elem.antenna
              + elem.antenna_serial_number
              + elem.radome
              + elem.receiver
              + elem.receiver_serial_number
              + elem.firmware
              + elem.satellites_system
              }
            >
              {/* Date */}
              <td key={elem.datefrom + Object.keys(elem.datefrom)}>{elem.datefrom} - {elem.dateto === elem.currentDate ? '' : elem.dateto}</td>

              {/* Antenna */}
              {(i === 0)
               && <td key={elem.antenna + Object.keys(elem.antenna)}>{elem.antenna}</td>}
              {(i !== 0 && elem.antenna === sessionViewData[i - 1].antenna)
               && <td key={elem.antenna + Object.keys(elem.antenna)}>{elem.antenna}</td>}
              {(i !== 0 && elem.antenna !== sessionViewData[i - 1].antenna)
               && <td style={{ backgroundColor: '#87E990' }} key={elem.antenna + Object.keys(elem.antenna)}>{elem.antenna}</td>}

              {/* Antenna Serial Number */}
              {(i === 0)
               && (
               <td key={elem.antenna_serial_number + Object.keys(elem.antenna_serial_number)}>
                 {elem.antenna_serial_number}
               </td>
               )}
              {(i !== 0 && elem.antenna_serial_number
              === sessionViewData[i - 1].antenna_serial_number)
               && (
               <td key={elem.antenna_serial_number + Object.keys(elem.antenna_serial_number)}>
                 {elem.antenna_serial_number}
               </td>
               )}
              {(i !== 0 && elem.antenna_serial_number
              !== sessionViewData[i - 1].antenna_serial_number)
               && <td style={{ backgroundColor: '#87E990' }} key={elem.antenna_serial_number + Object.keys(elem.antenna_serial_number)}>{elem.antenna_serial_number}</td>}

              {/* Radome */}
              {(i === 0)
               && <td key={elem.radome + Object.keys(elem.radome)}>{elem.radome}</td>}
              {(i !== 0 && elem.radome === sessionViewData[i - 1].radome)
               && <td key={elem.radome + Object.keys(elem.radome)}>{elem.radome}</td>}
              {(i !== 0 && elem.radome !== sessionViewData[i - 1].radome)
               && <td style={{ backgroundColor: '#87E990' }} key={elem.radome + Object.keys(elem.radome)}>{elem.radome}</td>}

              {/* Receiver */}
              {(i === 0)
               && <td key={elem.receiver + Object.keys(elem.receiver)}>{elem.receiver}</td>}
              {(i !== 0 && elem.receiver === sessionViewData[i - 1].receiver)
               && <td key={elem.receiver + Object.keys(elem.receiver)}>{elem.receiver}</td>}
              {(i !== 0 && elem.receiver !== sessionViewData[i - 1].receiver)
               && <td style={{ backgroundColor: '#87E990' }} key={elem.receiver + Object.keys(elem.receiver)}>{elem.receiver}</td>}

              {/* Receiver Serial Number */}
              {(i === 0)
               && (
               <td key={elem.receiver_serial_number + Object.keys(elem.receiver_serial_number)}>
                 {elem.receiver_serial_number}
               </td>
               )}
              {(i !== 0 && elem.receiver_serial_number
              === sessionViewData[i - 1].receiver_serial_number)
               && (
               <td key={elem.receiver_serial_number + Object.keys(elem.receiver_serial_number)}>
                 {elem.receiver_serial_number}
               </td>
               )}
              {(i !== 0 && elem.receiver_serial_number
              !== sessionViewData[i - 1].receiver_serial_number)
               && <td style={{ backgroundColor: '#87E990' }} key={elem.receiver_serial_number + Object.keys(elem.receiver_serial_number)}>{elem.receiver_serial_number}</td>}

              {/* Firmware */}
              {(i === 0)
               && <td key={elem.firmware + Object.keys(elem.firmware)}>{elem.firmware}</td>}
              {(i !== 0 && elem.firmware === sessionViewData[i - 1].firmware)
               && <td key={elem.firmware + Object.keys(elem.firmware)}>{elem.firmware}</td>}
              {(i !== 0 && elem.firmware !== sessionViewData[i - 1].firmware)
               && <td style={{ backgroundColor: '#87E990' }} key={elem.firmware + Object.keys(elem.firmware)}>{elem.firmware}</td>}

              {/* Satellites System */}
              {(i === 0)
               && (
               <td key={elem.satellites_system + Object.keys(elem.satellites_system)}>
                 {elem.satellites_system}
               </td>
               )}
              {(i !== 0 && elem.satellites_system === sessionViewData[i - 1].satellites_system)
               && (
               <td key={elem.satellites_system + Object.keys(elem.satellites_system)}>
                 {elem.satellites_system}
               </td>
               )}
              {(i !== 0 && elem.satellites_system !== sessionViewData[i - 1].satellites_system)
               && <td style={{ backgroundColor: '#87E990' }} key={elem.satellites_system + Object.keys(elem.satellites_system)}>{elem.satellites_system}</td>}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}

SessionView.propTypes = {
  sessionViewData: PropTypes.arrayOf(
    PropTypes.shape({
      datefrom: PropTypes.string.isRequired,
      dateto: PropTypes.string.isRequired,
      antenna: PropTypes.string.isRequired,
      antenna_serial_number: PropTypes.string.isRequired,
      radome: PropTypes.string.isRequired,
      receiver: PropTypes.string.isRequired,
      receiver_serial_number: PropTypes.string.isRequired,
      firmware: PropTypes.string.isRequired,
      satellites_system: PropTypes.string.isRequired,
      currentDate: PropTypes.string.isRequired,
    }).isRequired,
  ).isRequired,
};

export default SessionView;
